// extracted by mini-css-extract-plugin
export default {"arrow":"SliderArrows_arrow__giw0F"};